import { useMemo } from 'react'
import { isEmpty, join, map, pipe } from 'ramda'

import { Unperformed } from 'app/dataTypes/reports/data/common/ordersByClasses'
import styles from './unperformed.scss'


const warn = 'Данные в отчете некорректны. Имеются непроведенные заявки в следующих заведениях:'


type Props = {
  unperformed: Unperformed
}

export const UnperformedWarning = ({ unperformed }: Props) => {
  const unperformedValues = useMemo(() => {
    return pipe(
      map<any, string>(({ title }) => title),
      join(', '),
    )(unperformed)
  }, [unperformed])

  if (isEmpty(unperformed)) return null

  return (
    <div className={styles.root}>
      {`${warn} ${unperformedValues}`}
    </div>
  )
}
